import { useState } from "react";

const faqs = [
  {
    question: "Une fenêtre en bois se répare-t-elle facilement ?",
    answer:
      "Oui, dans la grande majorité des cas. Le cadre en bois est robuste et durable. C'est le mécanisme interne qui s'use ou se dérègle. Notre technicien accède au crémone, aux gonds ou à la poignée, et remplace la pièce défectueuse. Le bois permet un accès direct au mécanisme sans démontage complexe. L'intervention dure en moyenne 45 minutes. Vous ne changez pas la fenêtre, seulement la pièce usée. Nous réparons plus de 90% des fenêtres en bois rencontrées à Strasbourg et dans le Bas-Rhin.",
  },
  {
    question: "Les pièces sont-elles spécifiques aux fenêtres en bois ?",
    answer:
      "Oui, certaines pièces sont spécifiques. Le bois étant un matériau vivant qui se dilate, les mécanismes doivent tolérer des variations de position du vantail. Les gonds sont souvent plus solides pour supporter le poids du bois, et les crémones peuvent avoir des courses adaptées. Nous identifions la marque exacte sur place (Ferco, GU, Roto, Maco, Siegenia, etc.) et utilisons la pièce de remplacement correspondante. Nos techniciens connaissent les spécificités du bois et arrivent avec un stock de pièces courantes.",
  },
  {
    question: "Quel délai pour une réparation de fenêtre en bois à Strasbourg ?",
    answer:
      "Les fenêtres en bois ont des mécanismes plus robustes et parfois anciens. Nous emportons un stock de pièces adaptées aux mouvements du bois. Dans la métropole de Strasbourg, nous intervenons le jour même ou le lendemain. Pour les communes du Bas-Rhin comme Haguenau, Saverne ou Sélestat, le délai est de 24 à 48h. Le déplacement et le diagnostic sont toujours gratuits.",
  },
  {
    question: "Le prix de la réparation est-il dans le devis ?",
    answer:
      "Oui, le devis détaillé inclut le déplacement, le diagnostic, la pièce neuve adaptée au bois et la main d'œuvre. Les pièces pour fenêtres en bois sont souvent plus solides pour supporter le poids du vantail. Le devis est transparent et sans frais cachés. Vous savez exactement ce que vous payez avant l'intervention. Paiement à l'issue de la réparation. Garantie 10 ans.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — réparation fenêtre Bois
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-white rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}